module.exports = __webpack_public_path__ + "img/legacy-shape-11.04ccfe40.png";